(() => {
  const slides = document.querySelectorAll('.announce__slide');
  if (slides.length > 1) {
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4500);
  }
})();

document.querySelectorAll('[data-tabs]').forEach(group => {
  const tabs = group.querySelectorAll('.tab');
  const panels = group.querySelectorAll('.tab-panel');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      const panel = group.querySelector('#' + tab.dataset.target);
      if (panel) panel.classList.add('is-active');
    });
  });
});

const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

const burger = document.querySelector('.header__burger');
const nav = document.querySelector('.header__nav');
if (burger && nav) {
  burger.addEventListener('click', () => {
    nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', nav.classList.contains('is-open'));
  });
}

/* ============ CART DRAWER ============ */
const drawer = document.querySelector('[data-cart-drawer]');
const openDrawer = () => {
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};
const closeDrawer = () => {
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

document.querySelectorAll('[data-cart-open]').forEach(el => {
  el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
});

async function refreshDrawer() {
  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

    const html = await fetch(window.location.pathname + '?_t=' + Date.now()).then(r => r.text());
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('[data-cart-drawer]');
    if (fresh && drawer) {
      const wasOpen = drawer.getAttribute('aria-hidden') === 'false';
      drawer.innerHTML = fresh.innerHTML;
      if (wasOpen) drawer.setAttribute('aria-hidden', 'false');
      bindDrawerActions();
    }
  } catch (err) {
    console.warn('Drawer refresh failed', err);
  }
}

function bindDrawerActions() {
  document.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('[data-cart-item]').forEach(item => {
    const key = item.dataset.cartItem;
    const input = item.querySelector('[data-qty-input]');
    const up = item.querySelector('[data-qty-up]');
    const down = item.querySelector('[data-qty-down]');
    const remove = item.querySelector('[data-cart-remove]');

    const update = async (qty) => {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) refreshDrawer();
    };

    if (up) up.addEventListener('click', () => update(parseInt(input.value) + 1));
    if (down) down.addEventListener('click', () => update(Math.max(0, parseInt(input.value) - 1)));
    if (remove) remove.addEventListener('click', () => update(0));
  });
}

document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
bindDrawerActions();

// AJAX add to cart from PDP
const pdpForm = document.querySelector('[data-pdp-form]');
if (pdpForm) {
  pdpForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = pdpForm.querySelector('.pdp__atc');
    const original = btn.innerHTML;
    btn.innerHTML = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(pdpForm) });
      if (res.ok) {
        await refreshDrawer();
        openDrawer();
        btn.innerHTML = '✓ Added';
        setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1200);
      } else {
        btn.innerHTML = 'Sold out';
      }
    } catch (err) {
      btn.innerHTML = original;
      btn.disabled = false;
    }
  });
}
